<template>
  <div id="home">
    <k-loader v-if="!this.state.loaded"></k-loader>
    <k-nav ref="nav"></k-nav>
    <k-header></k-header>
    <k-slider ref="slider"></k-slider>
    <k-footer ref="footer" :fixed="true"></k-footer>
  </div>
</template>

<script>
import Loader from './Loader';
import Nav from './Nav';
import Header from './Header';
import Slider from './Slider';
import Footer from './Footer';
import store from '../store/Store';

export default {
  components: {
    'k-loader': Loader,
    'k-nav': Nav,
    'k-header': Header,
    'k-slider': Slider,
    'k-footer': Footer
  },
  data() {
    return {
      state: store.state
    }
  },
  mounted() {
    if (!this.state.loaded) {
      this.$refs.nav.$refs.icon.style.opacity = 0;
      setTimeout(() => {
        this.$refs.slider.animateMount();
      }, 2250);

      setTimeout(() => {
        this.$refs.nav.animateMount();
      }, 2500);
    }
  },
  beforeRouteLeave(route, redirect, next) {
    this.state.freeze = true;
    this.$refs.slider.animateUnmount();
    this.$refs.footer.animateUnmount();
    setTimeout(() => {
      next();
    }, 500);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue